import { BaseQueryFn } from '@reduxjs/toolkit/query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig } from 'axios';
import httpResource from 'modules/core/http-resource';

export type RestBaseQueryArgs =
  | string
  | {
      url: string;
      method?: AxiosRequestConfig['method'];
      params?: AxiosRequestConfig['params'];
      data?: AxiosRequestConfig['data'];
      headers?: AxiosRequestConfig['headers'];
      // возможность расширения без ломающих изменений
      withCredentials?: boolean;
      signal?: AbortSignal;
    };

export interface RestBaseQueryError {
  status?: number | 'ABORTED';
  data?: any;
  message?: string;
}

// Бэйз-квери для RTK Query на базе существующего httpResource (axios-инстанс).
// api.signal прокидывается в axios — так запрос отменяется при размонтировании
// подписчика, смене аргументов или явном .abort()
export const restBaseQuery: BaseQueryFn<RestBaseQueryArgs, unknown, RestBaseQueryError> = async (arg, api) => {
  try {
    let req: AxiosRequestConfig;

    if (typeof arg === 'string') {
      req = { url: arg, method: 'GET', signal: api.signal };
    } else {
      const { url, method = 'GET', params, data, headers, withCredentials, signal } = arg;
      req = { url, method, params, data, headers, withCredentials, signal: signal ?? api.signal };
    }

    const resp = await httpResource.client.request(req);
    return { data: resp.data } as any;
  } catch (error) {
    const e = error as AxiosError;

    // Отменённый запрос — не ошибка бэка, помечаем отдельным статусом
    if (axios.isCancel(error) || e.code === 'ERR_CANCELED') {
      return {
        error: {
          status: 'ABORTED',
          message: e.message,
        },
      } as any;
    }

    return {
      error: {
        status: e.response?.status,
        data: e.response?.data,
        message: e.message,
      },
    } as any;
  }
};

export default restBaseQuery;
